export const ADD_PASSCAT  ='PASS_TYPE';
export const FETCH_PASSCAT='FETCH_PASSCAT';
export const GET_PASSCAT='GET_PASSCAT';
export const MESSGAE ='MESSAGE';